import { de } from '../i18n/de';

/**
 * The five surfaces. There is no router dependency: this app has a fixed set of
 * screens, no URLs worth sharing, no history worth traversing, and one user. A
 * back button that could strand the person mid-sentence is a liability, not a
 * feature.
 */
export const SURFACES = ['sprechen', 'saetze', 'notfall', 'partner', 'betreuer'] as const;

export type SurfaceId = (typeof SURFACES)[number];

export const SURFACE_LABELS: Record<SurfaceId, string> = {
  sprechen: de.surfaceSprechen,
  saetze: de.surfaceSaetze,
  notfall: de.surfaceNotfall,
  partner: de.surfacePartnerAnsicht,
  betreuer: de.surfaceBetreuerModus,
};

/** Where the app opens. Typing is the primary path, so it is never anywhere else. */
export const HOME_SURFACE: SurfaceId = 'sprechen';
